import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { ETooltipAlign, ETooltipPlacement, Tooltip } from 'Shared/components';
import { DEFAULT_LENGTH_LIMIT } from 'Common/consts';
import styles from './TruncateString.css';
const TruncateString = ({ actualString, className, limit = DEFAULT_LENGTH_LIMIT, }) => {
    if (!actualString)
        return null;
    return (_jsx(_Fragment, { children: actualString.length > limit
            ? (_jsx(Tooltip, Object.assign({ placement: ETooltipPlacement.BottomCenter, align: ETooltipAlign.Center, tooltipContent: actualString, className: styles.tooltip }, { children: _jsx("span", Object.assign({ className: className }, { children: `${actualString.slice(0, limit)}...` }), void 0) }), void 0))
            : _jsx("span", Object.assign({ className: className }, { children: actualString }), void 0) }, void 0));
};
export default memo(TruncateString);
